@if(config().descriptionBlock?.isNullOrEmpty() === false) {
    <lsa-description-block [descriptionBlockConfig]="config().descriptionBlock!"></lsa-description-block>
}

@if(config().searchBox?.isNullOrEmpty() === false){
    <lsa-searchbox [config]="config().searchBox!" (searchQueryChange)="searchQuery.set($event)"></lsa-searchbox>
}

<div class="carrousel-wrapper">
    @if(showSpinner()){
        <mat-spinner></mat-spinner>
    }
    @else {
        <lsa-video-carrousel (videoClick)="onPlaylistClick($event)" [videoTitlePrefix]="'Curso: '" 
        [resetLeftScroll$]="searchQueryChanged$" [videos]="filteredPlaylists()"></lsa-video-carrousel>
    }
</div>
